import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=06da44de&scoped=true&"
import script from "./SecurityTab.vue?vue&type=script&lang=js&"
export * from "./SecurityTab.vue?vue&type=script&lang=js&"
import style0 from "./SecurityTab.vue?vue&type=style&index=0&id=06da44de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da44de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
